export function FreezeObjectProperty(target, propertyKey) {
    var descriptor = Object.getOwnPropertyDescriptor(target, propertyKey);
    if (descriptor === void 0) {
        throw new Error("Missing property " + String(propertyKey));
    }
    else {
        var value_1 = target[propertyKey];
        Object.defineProperty(target, propertyKey, {
            enumerable: descriptor.enumerable,
            configurable: false,
            get: function () { return value_1; },
        });
    }
    return target;
}
export function FreezeObjectProperties(target, propertyKeys) {
    var iterator = propertyKeys[Symbol.iterator]();
    var result;
    while (!(result = iterator.next()).done) {
        FreezeObjectProperty(target, result.value);
    }
    return target;
}
//# sourceMappingURL=freeze-property.js.map